import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { ContentDataService } from '@pages/info-center/services/content-data.service';

@Component({
  selector: 'app-responsible-gaming',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, TranslateModule],
  templateUrl: './responsible-gaming.component.html',
  styleUrl: './responsible-gaming.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResponsibleGamingComponent implements OnInit, OnDestroy {

  panelOpenState = false;
  responsibleGaming: any[] = [];
  mainContent: any;
  isSkeletonMainContent = true;

  private readonly isBrowser: boolean;
  private readonly destroy$ = new Subject<void>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private contentDataService: ContentDataService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.contentDataService.getResponsibleGaming()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.responsibleGaming = res?.contents?.rows ?? [];
        this.mainContent = res?.main_description;
        this.isSkeletonMainContent = false;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  scroll(id: string | number): void {
    if (!this.isBrowser) return;
    const el = document.getElementById(String(id));
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  sanitize(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(content ?? '');
  }

  trackByRowId(_index: number, row: any): string {
    return row.id;
  }
}
